// extracted by mini-css-extract-plugin
export var word = "SplitText-module--word--c95fa";